import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BillingInvoiceManualSearchComponent } from './billing-invoice-manual-search.component';
import { BillingInvoiceManualFilterComponent } from '../billing-invoice-manual-filter/billing-invoice-manual-filter.component';
import { ReactiveFormsModule } from '@angular/forms';
import { SharedModule } from '../../shared.module';
import { SharedMaterialModule } from '../../shared-material.module';
import { TableModule } from 'primeng/table';

@NgModule({
  declarations: [
    BillingInvoiceManualSearchComponent,
    BillingInvoiceManualFilterComponent
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    SharedModule,
    SharedMaterialModule,
    TableModule
  ]
})
export class BillingInvoiceManualSearchModule { }
